<template>
  <div class="px-7 py-0">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs7 mb-3 class="px-0 pb-0">
          <h3 class="darkblue--text breadcrumbs font-weight-700 fs-16 lh-16">
            TOPLINE REPORT
          </h3>
          <v-breadcrumbs
            class="px-0 subtitle-2 mt-0 pt-0 pb-0 breadcrumbs-items"
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          v-if="isLoggedInAsBO"
          color="primary"
          class="rounded-6 text-capitalize mt-4 mr-4"
          dark
          @click="getFiltered({ info: [], param: [], type: 'download' })"
        >
          Download
        </v-btn>
        <advance-filter
          title="topline"
          @getFiltered="getFiltered"
          class="pt-2"
          v-else
        />
        <v-flex xs2 class="text-center pb-0 pt-4 px-0">
          <date-picker
            v-model="year"
            type="year"
            placeholder="Year"
            format="YYYY"
            class="dashSearch filterSearch"
          >
          </date-picker>
        </v-flex>
      </v-layout>
      <v-flex
        xs12
        class="pa-0 grey--text font-weight-500 fs-12 lh-16"
        style="margin-top: -12px"
      >
        <v-row>
          <v-expansion-panels flat class="filterby-info">
            <v-expansion-panel>
              <v-expansion-panel-header
                class="grey--text fs-13 px-0 pt-0 pb-1 secondary"
                height="100px"
              >
                Filter By Information
              </v-expansion-panel-header>
              <v-expansion-panel-content class="grey--text secondary">
                <ul v-if="filterBy.length > 0">
                  <li
                    v-for="(filter, indexFilter) in filterBy"
                    :key="'filter' + indexFilter"
                    class="text-left"
                  >
                    {{ yearInfo }}
                    <template v-for="(detail, indexDetail) in filter">
                      {{ ' / ' }}
                      <span :key="'indexDetail-' + indexDetail">
                        {{ detail.map(e => e.name).join(' / ') }}
                      </span>
                    </template>
                  </li>
                </ul>
                <ul v-else>
                  <li>{{ yearInfo }}</li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-flex>
    </v-container>
    <v-layout class="table-non-po">
      <v-flex xs12>
        <!-- item kosong -->
        <v-card class="pb-4" v-if="items === undefined || items.length == 0">
          <v-card-title class="primary pa-2 white--text">
            <span id="titleBrand" class="title pl-2"></span>
            <v-spacer></v-spacer>
            <v-icon class="mr-4" color="white" id="removeBudget"
              >keyboard_arrow_down</v-icon
            >
          </v-card-title>
          <v-card-text class="pa-3">
            <v-layout row wrap class="">
              <v-flex xs12 class="py-0 pt-3 text-center">
                No data displayed
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-expansion-panels width="100%" multiple>
          <v-expansion-panel
            v-for="item in items"
            :key="item.division"
            class="mb-5 rounded-10 elevation-card"
            width="100%"
          >
            <v-expansion-panel-header
              expand-icon="keyboard_arrow_down"
              class="
                primary
                white--text
                px-4
                py-0
                rounded-bottom-left-10 rounded-bottom-right-10
              "
            >
              <template v-slot:actions>
                <v-icon color="white">keyboard_arrow_down</v-icon>
              </template>
              <template>
                <v-row no-gutters>
                  <span
                    class="font-weight-700 fs-16 lh-16 pl-1"
                    style="align-self: center"
                  >
                    {{ item.division }}
                  </span>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-card-text class="py-3 px-0">
                <v-layout row wrap>
                  <v-flex
                    class="pa-0"
                    v-for="(level, index) in item.data"
                    :key="'level' + index"
                  >
                    <v-row class="px-7 pt-1" align="center">
                      <img
                        src="@/assets/images/icon/file-text.png"
                        width="18px"
                        height="18px"
                      />
                      <span
                        class="
                          pl-2
                          font-weight-medium
                          subtitle-1
                          darkblue--text
                          fs-14
                          font-weight-700
                        "
                      >
                        {{ level.type === 'Summary' ? 'Summary' : 'By' }}
                        {{ level.name }}
                      </span>
                    </v-row>
                    <v-flex xs12 class="pa-0">
                      <v-data-table
                        v-if="level.type === 'Summary'"
                        class="px-4 pt-1 pb-3 radius-table"
                        dense
                        :headers="getHeaders(level)"
                        :items="level.data"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:header>
                          <thead>
                            <tr>
                              <th
                                :colspan="2"
                                style="
                                  background-color: #fff !important;
                                  border: none !important;
                                "
                              ></th>
                              <th
                                :colspan="3"
                                class="mr-3 rounded-10"
                                style="border: 1px solid #fff !important"
                              >
                                Year To Date
                                {{ showMonth + ' - ' + showYear }} (BIDR)
                              </th>
                              <th colspan="3" class="rounded-10">
                                Quarter {{ quarterYTD }} (BIDR)
                              </th>
                              <th
                                :colspan="3"
                                class="ml-3 rounded-10"
                                style="border: 1px solid #fff !important"
                              >
                                Semester {{ semesterYTD }} (BIDR)
                              </th>
                            </tr>
                            <tr>
                              <th
                                style="
                                  height: 1px !important;
                                  background-color: #fff !important;
                                  border: none !important;
                                "
                              ></th>
                            </tr>
                          </thead>
                        </template>
                        <template v-slot:body="{ items }">
                          <tbody>
                            <template v-if="items.length > 0">
                              <tr v-for="item in items" :key="item.id">
                                <td>{{ item.name || '-' }}</td>
                                <td class="text-right">
                                  {{ currFormatter2(item.totalBudget) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{
                                    currFormatter2(item.totalYearToDateIO) ||
                                      '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.totalPO) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.totalGR) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{
                                    currFormatter2(item.quarterYearToDateIO) ||
                                      '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.quarterPO) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.quarterGR) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{
                                    currFormatter2(item.semesterYearToDateIO) ||
                                      '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.semesterPO) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.semesterGR) || '-' }}
                                </td>
                              </tr>
                              <tr class="bgTotal">
                                <td
                                  class="font-weight-bold text-right border-l-0"
                                  style="z-index: 2 !important"
                                >
                                  TOTAL
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'totalBudget') ||
                                      '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(
                                      level.data,
                                      'totalYearToDateIO'
                                    ) || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'totalPO') || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'totalGR') || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(
                                      level.data,
                                      'quarterYearToDateIO'
                                    ) || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'quarterPO') ||
                                      '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'quarterGR') ||
                                      '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(
                                      level.data,
                                      'semesterYearToDateIO'
                                    ) || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'semesterPO') ||
                                      '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'semesterGR') ||
                                      '-'
                                  }}
                                </td>
                              </tr>
                            </template>
                            <tr v-else>
                              <td colspan="11" class="text-center">
                                No Data Displayed
                              </td>
                            </tr>
                          </tbody>
                        </template>
                        <template v-slot:no-data>
                          <label color="primary">No data displayed</label>
                        </template>
                      </v-data-table>
                      <v-data-table
                        v-else
                        class="px-4 pt-1 pb-3 radius-table"
                        dense
                        :headers="getHeaders(level)"
                        :items="level.data"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:header>
                          <thead>
                            <tr>
                              <th
                                :colspan="2"
                                style="
                                  background-color: #fff !important;
                                  border: none !important;
                                "
                              ></th>
                              <th
                                :colspan="3"
                                class="mr-3 rounded-10"
                                style="border: 1px solid #fff !important"
                              >
                                Year To Date
                                {{ showMonth + ' - ' + showYear }} (BIDR)
                              </th>
                              <th colspan="2" class="rounded-10">
                                Value (BIDR)
                              </th>
                              <th
                                :colspan="2"
                                class="ml-3 rounded-10"
                                style="border: 1px solid #fff !important"
                              >
                                Comparison (Ratio) - {{ showYear }}
                              </th>
                            </tr>
                            <tr>
                              <th
                                style="
                                  height: 1px !important;
                                  background-color: #fff !important;
                                  border: none !important;
                                "
                              ></th>
                            </tr>
                          </thead>
                        </template>
                        <template v-slot:body="{ items }">
                          <tbody>
                            <template v-if="items.length > 0">
                              <tr v-for="item in items" :key="item.id">
                                <td>{{ item.name || '-' }}</td>
                                <td class="text-right">
                                  {{ currFormatter2(item.totalBudget) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{
                                    currFormatter2(item.totalYearToDateIO) ||
                                      '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.totalPO) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.totalGR) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.differencePO) || '-' }}
                                </td>
                                <td class="text-right">
                                  {{ currFormatter2(item.differenceGR) || '-' }}
                                </td>
                                <td>
                                  <v-layout
                                    class="pa-0"
                                    v-if="item.percentagePOvsYTD !== null"
                                  >
                                    <v-flex xs4>{{
                                      item.percentagePOvsYTD.toFixed(0) + '%'
                                    }}</v-flex>
                                    <v-flex xs8 class="pt-2">
                                      <v-progress-linear
                                        height="6"
                                        :color="
                                          getColor(
                                            item.percentagePOvsYTD.toFixed(0)
                                          )
                                        "
                                        rounded
                                        :value="
                                          item.percentagePOvsYTD.toFixed(0)
                                        "
                                      ></v-progress-linear>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout class="pa-0" v-else>
                                    <v-flex xs4>{{ 0 + '%' }}</v-flex>
                                    <v-flex xs8 class="pt-2">
                                      <v-progress-linear
                                        height="6"
                                        :color="getColor(0)"
                                        rounded
                                        :value="0"
                                      ></v-progress-linear>
                                    </v-flex>
                                  </v-layout>
                                </td>
                                <td>
                                  <v-layout
                                    class="pa-0"
                                    v-if="item.percentageGRvsYTD !== null"
                                  >
                                    <v-flex xs4>{{
                                      item.percentageGRvsYTD.toFixed(0) + '%'
                                    }}</v-flex>
                                    <v-flex xs8 class="pt-2">
                                      <v-progress-linear
                                        height="6"
                                        :color="
                                          getColor(
                                            item.percentageGRvsYTD.toFixed(0)
                                          )
                                        "
                                        rounded
                                        :value="
                                          item.percentageGRvsYTD.toFixed(0)
                                        "
                                      ></v-progress-linear>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout class="pa-0" v-else>
                                    <v-flex xs4>{{ 0 + '%' }}</v-flex>
                                    <v-flex xs8 class="pt-2">
                                      <v-progress-linear
                                        height="6"
                                        :color="getColor(0)"
                                        rounded
                                        :value="0"
                                      ></v-progress-linear>
                                    </v-flex>
                                  </v-layout>
                                </td>
                                <td
                                  class="text-center font-weight-bold"
                                  :class="getColorText(item.percentageGRvsYTD)"
                                >
                                  {{ '#' + item.rank }}
                                </td>
                              </tr>
                              <tr class="bgTotal">
                                <td
                                  class="font-weight-bold text-right border-l-0"
                                  style="z-index: 2 !important"
                                >
                                  TOTAL
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'totalBudget') ||
                                      '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(
                                      level.data,
                                      'totalYearToDateIO'
                                    ) || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'totalPO') || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(level.data, 'totalGR') || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(
                                      level.data,
                                      'differencePO'
                                    ) || '-'
                                  }}
                                </td>
                                <td
                                  class="
                                    font-weight-bold
                                    text-right
                                    sticky-amount
                                  "
                                >
                                  {{
                                    totalAmountFor(
                                      level.data,
                                      'differenceGR'
                                    ) || '-'
                                  }}
                                </td>
                                <td class="sticky-amount"></td>
                                <td class="sticky-amount"></td>
                                <td class="sticky-amount"></td>
                              </tr>
                            </template>
                            <tr v-else>
                              <td colspan="10" class="text-center">
                                No Data Displayed
                              </td>
                            </tr>
                          </tbody>
                        </template>
                        <template v-slot:no-data>
                          <label color="primary">No data displayed</label>
                        </template>
                      </v-data-table>
                      <hr class="hr-line ma-4" />
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../components/progress_dialog';
import ACLMixin from '../../mixins/ACLMixin';
import Swal from 'sweetalert2';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import advanceFilter from '@/components/advanceFilter/DynamicFilter';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'advance-filter': advanceFilter
  },
  mixins: [ACLMixin, LoginAsMixin],
  data() {
    return {
      panel: [0, 1],
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsEdit: {
        maxScrollbarLength: 220
      },
      progressDialogLoading: false,
      breadcrumbs: [
        {
          text: 'DASHBOARD',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'TOPLINE REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      year: new Date(),
      showYear: moment(new Date()).format('YYYY'),
      showMonth: moment(this.year).format('MMMM'),
      items: [],
      descending: true,
      sort: '',
      // advance filter properties
      filters: [],
      filter: '',
      baseUrl: process.env.VUE_APP_BASE_URL,
      profile_id: null,
      filterBy: '',
      divId: [],
      groupId: [],
      boId: [],
      paramFiltered: [
        {
          divisionIds: [],
          houseIds: [],
          groupIds: [],
          budgetOwnerIds: []
        }
      ]
    };
  },
  computed: {
    ...mapState('auth', ['userRole']),
    ...mapGetters('auth', ['userMapping']),
    yearInfo() {
      return moment(this.year).format('YYYY');
    },
    quarterYTD() {
      if (this.showMonth === 'December') {
        return 4;
      } else {
        let date = new Date();
        let month = date.getMonth() + 1;
        return Math.ceil(month / 3);
      }
    },
    semesterYTD() {
      if (this.showMonth === 'December') {
        return 2;
      } else {
        let date = new Date();
        let month = date.getMonth() + 1;
        return Math.ceil(month / 6);
      }
    }
  },
  watch: {
    year(val) {
      this.getData(val);
    }
  },
  async mounted() {
    this.profile_id = Number(localStorage.getItem('profile_id'));
    await this.getData(this.year);
  },
  methods: {
    getHeaders(level) {
      let headers_summary = [
        {
          text: level.name,
          value: 'name',
          sortable: false
        },
        {
          text: 'FY Budget',
          value: 'totalBudget',
          sortable: false
        },
        {
          text: 'IO',
          value: 'totalYearToDateIO',
          sortable: false
        },
        {
          text: 'PO & Non-PO',
          value: 'totalPO',
          sortable: false
        },
        {
          text: 'GR & Act',
          value: 'totalGR',
          sortable: false
        },
        {
          text: 'IO',
          value: 'quarterYearToDateIO',
          sortable: false
        },
        {
          text: 'PO & Non-PO',
          value: 'quarterPO',
          sortable: false
        },
        {
          text: 'GR & Act',
          value: 'quarterGR',
          sortable: false
        },
        {
          text: 'IO',
          value: 'semesterYearToDateIO',
          sortable: false
        },
        {
          text: 'PO & Non-PO',
          value: 'semesterPO',
          sortable: false
        },
        {
          text: 'GR & Act',
          value: 'semesterGR',
          sortable: false
        }
      ];
      let headers_topline = [
        {
          text: level.name,
          value: 'name',
          sortable: false
        },
        {
          text: 'FY Budget',
          value: 'totalBudget',
          sortable: false,
          align: 'right'
        },
        {
          text: 'IO',
          value: 'totalYearToDateIO',
          sortable: false,
          align: 'right'
        },
        {
          text: 'PO & Non-PO',
          value: 'totalPO',
          sortable: false,
          align: 'right'
        },
        {
          text: 'GR & Act',
          value: 'totalGR',
          sortable: false,
          align: 'right'
        },
        {
          text: 'To be PO',
          value: 'differencePO',
          sortable: false,
          align: 'right'
        },
        {
          text: 'To be GR',
          value: 'differenceGR',
          sortable: false,
          align: 'right'
        },
        {
          text: 'PO & Non-PO vs IO',
          value: 'percentagePOvsYTD',
          sortable: false
        },
        {
          text: 'GR & Act vs IO',
          value: 'percentageGRvsYTD',
          sortable: false
        },
        {
          text: 'Rank',
          value: 'rank',
          sortable: false,
          align: 'center'
        }
      ];
      return level.type === 'Summary' ? headers_summary : headers_topline;
    },
    getFiltered(val) {
      console.log('download', val);
      this.filterBy = val.info;
      this.paramFiltered = val.param;
      // this.divId = val.param
      //   .filter(div => {
      //     return div.type.toLowerCase() === 'division';
      //   })
      //   .map(div => {
      //     return div.id;
      //   });
      // this.groupId = val.param
      //   .filter(div => {
      //     return div.type.toLowerCase() === 'group';
      //   })
      //   .map(div => {
      //     return div.id;
      //   });
      // this.boId = val.param
      //   .filter(div => {
      //     return div.type.toLowerCase() === 'budget owner';
      //   })
      //   .map(div => {
      //     return div.id;
      //   });

      switch (val.type) {
        case 'download':
          this.downloadData();
          break;
        case 'report':
          this.getData(this.year);
          break;
      }
    },
    totalAmountFor(item, key) {
      return this.currFormatter2(
        item.reduce((total, val) => {
          const value = +(val[key] || 0);
          total += value;
          return total;
        }, 0)
      ).toLocaleString('id');
    },
    getColor(val) {
      let color = '';
      if (val >= 0 && val <= 59) {
        color = 'softRed';
      } else if (val >= 60 && val <= 89) {
        color = 'lime';
      } else if (val >= 90) {
        color = 'green darken-1';
      }
      return color;
    },
    getColorText(val) {
      let color = '';
      if (val >= 0 && val <= 59) {
        color = 'red--text';
      } else if (val >= 60 && val <= 89) {
        color = 'lime--text';
      } else if (val >= 90) {
        color = 'green--text text--darken-1';
      }
      return color;
    },
    getBackground(val) {
      let bgColor = '';
      if (this.isLoggedInAsBO) {
        if (val === this.profile_id) {
          bgColor = 'bgTotal font-weight-bold';
        }
        return bgColor;
      }
    },
    getData(year) {
      this.progressDialogLoading = true;
      let date = new Date();
      let month = '';
      if (!year) {
        year = moment(date).format('YYYY');
      } else {
        year = moment(year).format('YYYY');
      }
      if (year === moment(date).format('YYYY')) {
        month = moment(date).format('M');
        this.showMonth = moment(date).format('MMMM');
      } else {
        month = 12;
        this.showMonth = 'December';
      }
      this.showYear = year;
      return this.$store
        .dispatch('dashboard/getTopline', {
          year,
          month,
          profileId: this.userMapping.profile_id,
          filter: this.paramFiltered
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.items = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    downloadData() {
      let filters = '';
      if (this.paramFiltered.length > 0) {
        for (var i = 0; i < this.paramFiltered.length; i++) {
          filters +=
            `&filter[]={"divisionIds":[${this.paramFiltered[i].divisionIds}],` +
            `"houseIds":[${this.paramFiltered[i].houseIds}],` +
            `"groupIds":[${this.paramFiltered[i].groupIds}],` +
            `"budgetOwnerIds":[${this.paramFiltered[i].budgetOwnerIds}]}`;
        }
      }
      //param month & year
      let date = new Date();
      let month = '';
      let year = '';
      if (!this.year) {
        year = moment(date).format('YYYY');
      } else {
        year = moment(this.year).format('YYYY');
      }
      if (year === moment(date).format('YYYY')) {
        month = moment(date).format('M');
        this.showMonth = moment(date).format('MMMM');
      } else {
        month = 12;
        this.showMonth = 'December';
      }
      let profile_id = localStorage.getItem('profile_id');
      window.open(
        this.baseUrl +
          '/v2/report/topline?profileId=' +
          profile_id +
          '&year=' +
          year +
          '&month=' +
          month +
          '&export=yes' +
          filters +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
<style>
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active
  .v-data-table-header__icon {
  color: #fff !important;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: #fff !important;
}
.br-25 {
  border-radius: 5px !important;
}
.thwhite {
}
.table-non-po table {
  /* display: block; */
}
.table-non-po table th,
.table-non-po table td {
  /* white-space: nowrap !important; */
  border: 1px solid rgba(0, 0, 0, 0.12);
}
/* width */
.table-non-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-non-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-non-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-non-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-non-po .theme--light.v-data-table thead tr th {
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  letter-spacing: -0.02em !important;
  text-align: center !important;
  border-right: 1px solid #0000001f;
  height: 30px !important;
  color: #fff !important;
  background: #28a0f6 !important;
}
</style>
